import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Link } from "react-router-dom";

const useStyles = makeStyles()((theme) => ({
  textDiv: {
    paddingBottom: 10,
  },
  footerlink: {
    color: "black",
    textDecoration: "none",
    fontSize: "1rem",
    padding: 0,
    textTransform: "none",
    fontWeight: "normal",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  },
}));

export default function FooterLink(props) {
  const { classes } = useStyles();
  let { href, text, isExternalLink, onClick = null } = props;

  return (
    <div className={classes.textDiv}>
      {isExternalLink ? (
        <Typography
          component="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.footerlink}
          onClick={onClick}
        >
          {text}
        </Typography>
      ) : (
        <Typography component={Link} to={href} className={classes.footerlink}>
          {text}
        </Typography>
      )}
    </div>
  );
}
